// extracted by mini-css-extract-plugin
export default {"navitems":"hamburger_navitems__yk+mV","navbardiv":"hamburger_navbardiv__iLjLz"};